import List from "@mui/material/List";
import Paper from "@mui/material/Paper";
import { useTranslation } from "react-i18next";

import { LEGAL_ITEMS } from "~/components/settings/settings-nav";
import { SettingsPage } from "~/components/settings/SettingsPage";
import { SettingsRow } from "~/components/settings/SettingsRow";

/** Keep legal reading separate from actions that change the member's account. */
export function LegalInformationRoute() {
  const { t } = useTranslation();

  return (
    <SettingsPage title={t("legal.title")}>
      <Paper variant="outlined" sx={{ overflow: "hidden" }}>
        <List disablePadding>
          {LEGAL_ITEMS.map((item, index) => (
            <SettingsRow
              key={item.key}
              item={item}
              label={t(item.labelKey)}
              first={index === 0}
            />
          ))}
        </List>
      </Paper>
    </SettingsPage>
  );
}
